import {subscribeExt} from "../modules/subscribe";

export function chronicleDetailPage() {

    function showViewport() {
        var selector    = document.querySelector('.chronicle-wrp');
        var height      = Math.max(selector.clientHeight, window.innerHeight || 0);
        $('.side-overlay').css({'height': height+'px'});

        var $window = $(window);
        var $sidebar = $("#chronicle-detail-sidebar");
        var $sibling_block_height = $('.chronicle-wrp');
        var $sidebarHeight = $sidebar.innerHeight();


        /*if($sidebarHeight < $sibling_block_height.innerHeight() - 200){

            var $footerOffsetTop = $(".subscribe-wrp").offset().top - 30;
            var $sidebarOffset = $sidebar.offset();


            $window.scroll(function() {
                if($window.scrollTop() > $sidebarOffset.top) {
                    $sidebar.addClass("relative");
                } else {
                    $sidebar.removeClass("relative");
                }
                if($window.scrollTop() + $sidebarHeight > $footerOffsetTop) {
                    //$sidebar.css({"top" : -($window.scrollTop() + $sidebarHeight - $footerOffsetTop)});
                    $sidebar.css({"width" : '100%'});
                } else {
                    $sidebar.css({"top": "0",});
                }
            });
        }*/
    }

    function actions() {

        if($('body').hasClass('single-secular-chronicle')){
            subscribeExt(500);
        }

        if ($('.single-chronicle').length > 0) {
            window.onload = showViewport;
            window.onresize = showViewport;
        }
    }

    actions();
}


// WEBPACK FOOTER //
// ./assets/js/pages/chronicle_detail.js